import React, {useRef, useState} from 'react';

//champs texte classique
const CustomFieldText = ({label="", name, id=name, placeholder="", type="text", register, error, className="", value=""} ) =>{

	const [inputType,setInputType] = useState(type)
	label = label.replace("*","<span>*</span>");

	const togglePassword = () => {
		if(inputType === "password")
			setInputType("text")
		else
			setInputType("password")
	}

	return(
		<div className={"form_row_wrapper"} id={"form_row_wrapper_"+name}>
			{label !== "" &&
				<div className={"label_wrapper"}>
					<label htmlFor={id} dangerouslySetInnerHTML={{__html: label}}/>
				</div>
			}
			<div className={"input_wrapper"}>
				{type === "password" && <button type={"button"} className={"show_password"} onClick={togglePassword}/> }
				<input className={className} type={inputType} id={id} name={name} defaultValue={value} placeholder={placeholder} {...register}/>
			</div>
			<div className="error">{error}</div>
		</div>
	);
}

export default CustomFieldText;